import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import ThumbDown from '@mui/icons-material/ThumbDown';
import ThumbUp from '@mui/icons-material/ThumbUp';

import { Typo } from 'uikit/content';
import { Button } from 'uikit/buttons';

import styles from '../styles/videoContentRatingActions.module.scss';

const VideoContentRatingActions = ({ currentVote = undefined, handleVote, isLoading }) => (
  <div className={styles.element}>
    <Typo className={styles.text} weight="medium">{i18n.t('was-this-content-helpful')}</Typo>
    <Button
      text={i18n.t('yes')}
      icon={<ThumbUp />}
      variant="outlined"
      onClick={() => handleVote({ vote: currentVote === 1 ? 0 : 1 })}
      isSelected={currentVote === 1}
      isDisabled={isLoading}
    />
    <Button
      text={i18n.t('no')}
      icon={<ThumbDown />}
      variant="outlined"
      onClick={() => handleVote({ vote: currentVote === -1 ? 0 : -1 })}
      isSelected={currentVote === -1}
      isDisabled={isLoading}
    />
  </div>
);

VideoContentRatingActions.propTypes = {
  currentVote: PropTypes.number,
  handleVote: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default React.memo(VideoContentRatingActions);
